<div class="layout-ParentDiv innerDiv imagePage ConvenienceFeePage">
  <div class="layout-dashboard addPage">
    <div class="p-grid">
      <div class="p-col-12 mainFormPadding">
        <div class="card  ">
          <p-toast key="toastmsg"></p-toast>
          <form [formGroup]="chargesFormGroup">
            <div class="p-fluid p-formgrid p-grid m-0">
              <div class="p-field p-col-12 div-border p-p-0">
                <h3 class="head-page-title">
                  {{pagetitle}}
                </h3>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid chargesListMain">
              <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap chargesList"
                *ngFor="let platformModule of platformModulesList; let i=index">
                <div class="p-field p-col-12" [formGroupName]="platformModule?.name.toLowerCase()">
                  <label><b>{{ platformModule?.name }}</b></label>
                  <ul class="mainFormList">
                    <li> 
                      <div class="mainFormDiv">
                        <div>
                          <div class="maingrid">
                            <div class="p-field p-col">
                              <input type="number" placeholder="Enter Platform fee" formControlName="platformFee"
                                pInputText
                                [ngClass]="{ 'is-invalid': submitted && f(platformModule?.name).platformFee.errors }" />
                              <div *ngIf="submitted && f(platformModule?.name).platformFee.errors"
                                class="invalid-feedback">
                                <div *ngIf="f(platformModule?.name).platformFee.errors.required">PlatForm Fee is
                                  required</div>
                                <div *ngIf="f(platformModule?.name).platformFee.errors.min">Miminum price should atleast
                                  ₹1
                                </div>
                                <div *ngIf="f(platformModule?.name).platformFee.errors.percentageValidator">Please enter
                                  percentage between 0 to 100</div>
                              </div>
                            </div>

                            <div class="p-field p-col addFormDropDown">
                              <p-dropdown formControlName="platformFeeType" [options]="feeTypes" [filter]="false" appendTo="body"
                                [showClear]="false" optionLabel="name" placeholder="Select Platform fee type"
                                [ngClass]="{ 'is-invalid': submitted && f(platformModule?.name).platformFeeType.errors }"
                                (onChange)="onSelectPlatformFeeType($event,platformModule?.name)"></p-dropdown>
                              <div *ngIf="submitted && f(platformModule?.name).platformFeeType.errors"
                                class="invalid-feedback">
                                <div *ngIf="f(platformModule?.name).platformFeeType.errors.required">PlatForm Fee type
                                  is
                                  required</div>
                              </div>
                            </div>

                            <div class="p-field d-flex">
                              <p-inputSwitch class="checkbox-mt-10" formControlName="platformFeeStatus"  appendTo="body"
                                (onChange)="onPlatFormFeeStatusChange($event,platformModule?.name)"
                                [ngClass]="{ 'is-invalid': submitted && f(platformModule?.name).platformFeeStatus.errors }"></p-inputSwitch>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li> 
                      <div class="mainFormDiv">
                        <div>
                          <div class="maingrid">
                            <div class="p-field p-col">
                              <input type="number" placeholder="Enter Convenience fee" formControlName="convenienceFee"
                                pInputText
                                [ngClass]="{ 'is-invalid': submitted && f(platformModule?.name).convenienceFee.errors }" />
                              <div *ngIf="submitted && f(platformModule?.name).convenienceFee.errors"
                                class="invalid-feedback">
                                <div *ngIf="f(platformModule?.name).convenienceFee.errors.required">Convenience Fee is
                                  required
                                </div>
                                <div *ngIf="f(platformModule?.name).convenienceFee.errors.min">Miminum price should
                                  atleast ₹1
                                </div>
                                <div *ngIf="f(platformModule?.name).convenienceFee.errors.percentageValidator">Please
                                  enter
                                  percentage between 0 to 100</div>
                              </div>
                            </div> 
                            <div class="p-field p-col addFormDropDown">
                              <p-dropdown formControlName="convenienceFeeType" [options]="feeTypes" [filter]="false"  appendTo="body"
                                [showClear]="false" optionLabel="name" placeholder="Select Convenience fee type"
                                [ngClass]="{ 'is-invalid': submitted && f(platformModule?.name).convenienceFeeType.errors }"
                                (onChange)="onSelectConvenienceFeeType($event,platformModule?.name)"></p-dropdown>
                              <div *ngIf="submitted && f(platformModule?.name).convenienceFeeType.errors"
                                class="invalid-feedback">
                                <div *ngIf="f(platformModule?.name).convenienceFeeType.errors.required">Convenience Fee
                                  Type is
                                  required</div>
                              </div>
                            </div> 
                            <div class="p-field  d-flex">
                              <p-inputSwitch class="checkbox-mt-10" formControlName="convenienceFeeStatus"  appendTo="body"
                                (onChange)="onConvenienceFeeStatusChange($event,platformModule?.name)"
                                [ngClass]="{ 'is-invalid': submitted && f(platformModule?.name).convenienceFeeStatus.errors }"></p-inputSwitch>
                            </div>
                          </div>
                        </div>
                      </div> 
                    </li>
                  </ul>
                </div>
              </div> 
            </div>
            <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
              <div class="p-formgrid p-grid">
                <p-toast></p-toast>
                <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                  class="p-button-success save-btn p-mr-0" style="width: auto"></button>
                <p-confirmDialog header="Confirmation" key="confirm1" icon="pi pi-exclamation-triangle"
                  message="Are you sure you want to proceed?" [style]="{width: '425px'}"
                  acceptButtonStyleClass="p-button-text" rejectButtonStyleClass="p-button-text"></p-confirmDialog>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>